// This file is auto-generated. Do not edit it manually.


export type StaticAssetPath =
  'images/arduino-logo-full.svg' |
  'images/arduino-logo-round.svg' |
  'images/arduino-logo-squared.png' |
  'images/branding/cloudfavicon.dark.svg' |
  'images/branding/cloudfavicon.svg' |
  'images/branding/cloudhome.svg' |
  'images/branding/cloudsidebar.svg' |
  'images/classroom-logo.svg' |
  'images/cloud-logo.svg' |
  'images/covers/celebration.dark.svg' |
  'images/covers/celebration.svg' |
  'images/covers/connect-device.dark.svg' |
  'images/covers/connect-device.svg' |
  'images/covers/device-alert.dark.svg' |
  'images/covers/device-alert.svg' |
  'images/covers/device-confirm.dark.svg' |
  'images/covers/device-confirm.svg' |
  'images/covers/device-warning.dark.svg' |
  'images/covers/device-warning.svg' |
  'images/covers/documentation.dark.svg' |
  'images/covers/documentation.svg' |
  'images/covers/get-started.dark.svg' |
  'images/covers/get-started.svg' |
  'images/covers/no-device-found.dark.svg' |
  'images/covers/no-device-found.svg' |
  'images/dashboards/empty/1.dark.svg' |
  'images/dashboards/empty/1.svg' |
  'images/dashboards/empty/2.dark.svg' |
  'images/dashboards/empty/2.svg' |
  'images/dashboards/empty/3.dark.svg' |
  'images/dashboards/empty/3.svg' |
  'images/devices/boards/device-generic.svg' |
  'images/devices/boards/device-mega.svg' |
  'images/devices/boards/device-mkr.svg' |
  'images/devices/boards/device-nano.svg' |
  'images/devices/boards/device-opta.svg' |
  'images/devices/boards/device-phone.svg' |
  'images/devices/boards/device-portenta.svg' |
  'images/devices/boards/device-uno.svg' |
  'images/devices/boards/device-unoq.svg' |
  'images/devices/boards/device-ventunoq.svg' |
  'images/devices/chromeos_uploader/chromebook-reset-warning.png' |
  'images/devices/chromeos_uploader/flash.png' |
  'images/devices/device-alert.dark.svg' |
  'images/devices/device-alert.svg' |
  'images/devices/device-not-found.dark.svg' |
  'images/devices/device-not-found.svg' |
  'images/devices/empty-ota-list.dark.svg' |
  'images/devices/empty-ota-list.svg' |
  'images/devices/empty/1.dark.svg' |
  'images/devices/empty/1.svg' |
  'images/devices/empty/2.dark.svg' |
  'images/devices/empty/2.svg' |
  'images/devices/empty/3.dark.svg' |
  'images/devices/empty/3.svg' |
  'images/devices/qr-dev.jpeg' |
  'images/devices/qr-prod.jpeg' |
  'images/getting-started/1.dark.svg' |
  'images/getting-started/1.svg' |
  'images/getting-started/2.dark.svg' |
  'images/getting-started/2.svg' |
  'images/getting-started/3.dark.svg' |
  'images/getting-started/3.svg' |
  'images/getting-started/4.dark.svg' |
  'images/getting-started/4.svg' |
  'images/illustrations/auth-error.dark.svg' |
  'images/illustrations/auth-error.svg' |
  'images/illustrations/celebration.dark.svg' |
  'images/illustrations/celebration.svg' |
  'images/illustrations/createspace-edu.dark.svg' |
  'images/illustrations/createspace-edu.svg' |
  'images/illustrations/generic-error.dark.svg' |
  'images/illustrations/generic-error.svg' |
  'images/illustrations/generic-warning.dark.svg' |
  'images/illustrations/generic-warning.svg' |
  'images/illustrations/no-results.dark.svg' |
  'images/illustrations/no-results.svg' |
  'images/illustrations/sharing.svg' |
  'images/integration/aws.dark.png' |
  'images/integration/aws.png' |
  'images/integration/blues.dark.png' |
  'images/integration/blues.png' |
  'images/integration/edge_impulse.png' |
  'images/integration/foundries.dark.png' |
  'images/integration/foundries.png' |
  'images/integration/google_apps_script.png' |
  'images/integration/google_classroom.png' |
  'images/integration/grafana_labs.dark.png' |
  'images/integration/grafana_labs.png' |
  'images/integration/ifttt.png' |
  'images/integration/node_red.dark.png' |
  'images/integration/node_red.png' |
  'images/integration/the_things_stack.png' |
  'images/integration/zapier.png' |
  'images/kits/AEKR2.png' |
  'images/kits/AESK.png' |
  'images/kits/BLOCK_BASED.png' |
  'images/kits/BRACCIO.png' |
  'images/kits/CTC101.png' |
  'images/kits/CTCGO.png' |
  'images/kits/ENGINEERING.png' |
  'images/kits/EXPLORE_PHYSICS.png' |
  'images/kits/EXPLORE_PLC.png' |
  'images/kits/EXPLORE_ROBOTICS.png' |
  'images/kits/GREENHOUSE.png' |
  'images/kits/IOTSK.png' |
  'images/kits/IOTSK2.png' |
  'images/kits/MATTER_DISCOVERY.svg' |
  'images/kits/OPLA.png' |
  'images/kits/PHYSICSLAB.png' |
  'images/kits/PlUG_AND_MAKE.png' |
  'images/kits/SJ.png' |
  'images/kits/STARTERKIT_R4.png' |
  'images/kits/STUDENTKIT.png' |
  'images/minorscontent/apple.svg' |
  'images/minorscontent/arduinoIDEIcon.png' |
  'images/minorscontent/arduinoIDEImg.png' |
  'images/minorscontent/google.svg' |
  'images/minorscontent/info2.png' |
  'images/provisioning/any-device.dark.svg' |
  'images/provisioning/any-device.svg' |
  'images/provisioning/arduino-board.dark.svg' |
  'images/provisioning/arduino-board.svg' |
  'images/provisioning/bluetooth-connection.dark.svg' |
  'images/provisioning/bluetooth-connection.svg' |
  'images/provisioning/board-short-ble.svg' |
  'images/provisioning/compatible-device.dark.svg' |
  'images/provisioning/compatible-device.svg' |
  'images/provisioning/configuration-modal-abort.dark.svg' |
  'images/provisioning/configuration-modal-abort.svg' |
  'images/provisioning/device-list.dark.svg' |
  'images/provisioning/device-list.svg' |
  'images/provisioning/new-device.dark.svg' |
  'images/provisioning/new-device.svg' |
  'images/provisioning/unoq.dark.svg' |
  'images/provisioning/unoq.svg' |
  'images/provisioning/usb-connection.dark.svg' |
  'images/provisioning/usb-connection.svg' |
  'images/resources/circuit.svg' |
  'images/resources/discord.svg' |
  'images/resources/help.svg' |
  'images/resources/micropython.png' |
  'images/resources/user.svg' |
  'images/resources/youtube.svg' |
  'images/setup/educators.png' |
  'images/setup/intro.png' |
  'images/setup/share-course.png' |
  'images/sidebar-joinbanner.jpg' |
  'images/sketches/empty/1.dark.svg' |
  'images/sketches/empty/1.svg' |
  'images/sketches/empty/2.dark.svg' |
  'images/sketches/empty/2.svg' |
  'images/sketches/empty/3.dark.svg' |
  'images/sketches/empty/3.svg' |
  'images/space-nologo.png' |
  'images/templates/empty/1.dark.svg' |
  'images/templates/empty/1.svg' |
  'images/templates/empty/2.dark.svg' |
  'images/templates/empty/2.svg' |
  'images/templates/empty/3.dark.svg' |
  'images/templates/empty/3.svg' |
  'images/templates/empty/builder.dark.svg' |
  'images/templates/empty/builder.svg' |
  'images/templates/template-not-found.dark.svg' |
  'images/templates/template-not-found.svg' |
  'images/things/delete-smart-home.dark.svg' |
  'images/things/delete-smart-home.svg' |
  'images/things/empty/1.dark.svg' |
  'images/things/empty/1.svg' |
  'images/things/empty/2.dark.svg' |
  'images/things/empty/2.svg' |
  'images/things/empty/3.dark.svg' |
  'images/things/empty/3.svg' |
  'images/things/smart-home-integration.dark.svg' |
  'images/things/smart-home-integration.svg' |
  'images/things/thing-not-found.dark.svg' |
  'images/things/thing-not-found.svg' |
  'images/things/variables/empty.dark.svg' |
  'images/things/variables/empty.svg' |
  'images/things/variables/sync.dark.svg' |
  'images/things/variables/sync.svg' |
  'images/things/webhooks.dark.svg' |
  'images/things/webhooks.svg' |
  'images/triggers/empty/1.dark.svg' |
  'images/triggers/empty/1.svg' |
  'images/triggers/empty/2.dark.svg' |
  'images/triggers/empty/2.svg' |
  'images/triggers/empty/3.dark.svg' |
  'images/triggers/empty/3.svg' |
  'images/triggers/empty/thing-triggers-empty.dark.svg' |
  'images/triggers/empty/thing-triggers-empty.svg' |
  'images/triggers/trigger-not-found.dark.svg' |
  'images/triggers/trigger-not-found.svg' |
  'lottie/dashboards/dashboard-pages.lottie' |
  'lottie/provisioning/connected/BLE_connecting_MEGA.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_MEGA.lottie' |
  'lottie/provisioning/connected/BLE_connecting_MKR.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_MKR.lottie' |
  'lottie/provisioning/connected/BLE_connecting_NANO.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_NANO.lottie' |
  'lottie/provisioning/connected/BLE_connecting_OPTA.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_OPTA.lottie' |
  'lottie/provisioning/connected/BLE_connecting_PORTENTA.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_PORTENTA.lottie' |
  'lottie/provisioning/connected/BLE_connecting_UNOR4.dark.lottie' |
  'lottie/provisioning/connected/BLE_connecting_UNOR4.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_MEGA.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_MEGA.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_MKR.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_MKR.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_NANO.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_NANO.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_OPTA.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_OPTA.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_PORTENTA.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_PORTENTA.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_UNOR4.dark.lottie' |
  'lottie/provisioning/connected/SERIAL_connecting_UNOR4.lottie' |
  'lottie/provisioning/connectivity_type/connectivity_type_OPTA.dark.lottie' |
  'lottie/provisioning/connectivity_type/connectivity_type_OPTA.lottie' |
  'lottie/provisioning/connectivity_type/connectivity_type_PORTENTA.dark.lottie' |
  'lottie/provisioning/connectivity_type/connectivity_type_PORTENTA.lottie' |
  'lottie/provisioning/error/Error_Generic.dark.lottie' |
  'lottie/provisioning/error/Error_Generic.lottie' |
  'lottie/provisioning/scanning/BLE_scanning_GENERIC.dark.lottie' |
  'lottie/provisioning/scanning/BLE_scanning_GENERIC.lottie' |
  'lottie/provisioning/scanning/SERIAL_scanning_GENERIC.dark.lottie' |
  'lottie/provisioning/scanning/SERIAL_scanning_GENERIC.lottie' |
  'lottie/provisioning/template/template_apply.dark.lottie' |
  'lottie/provisioning/template/template_apply.lottie' |
  'lottie/smartfolders/new-feature_smart-folder.lottie' |
  'video/changelog/darktheme.dark.mp4' |
  'video/changelog/darktheme.mp4' |
  'video/changelog/sidebar.dark.mp4' |
  'video/changelog/sidebar.mp4' |
  'video/changelog/thing.dark.mp4' |
  'video/changelog/thing.mp4' |
  'video/walkthrough.mp4';

/**
 * Represents the known directories containing static assets.
 * '.' represents the root directory.
 */
export type StaticAssetDirectory =
  'images/' |
  'images/branding/' |
  'images/covers/' |
  'images/dashboards/' |
  'images/dashboards/empty/' |
  'images/devices/' |
  'images/devices/boards/' |
  'images/devices/chromeos_uploader/' |
  'images/devices/empty/' |
  'images/getting-started/' |
  'images/illustrations/' |
  'images/integration/' |
  'images/kits/' |
  'images/minorscontent/' |
  'images/provisioning/' |
  'images/resources/' |
  'images/setup/' |
  'images/sketches/' |
  'images/sketches/empty/' |
  'images/templates/' |
  'images/templates/empty/' |
  'images/things/' |
  'images/things/empty/' |
  'images/things/variables/' |
  'images/triggers/' |
  'images/triggers/empty/' |
  'lottie/' |
  'lottie/dashboards/' |
  'lottie/provisioning/' |
  'lottie/provisioning/connected/' |
  'lottie/provisioning/connectivity_type/' |
  'lottie/provisioning/error/' |
  'lottie/provisioning/scanning/' |
  'lottie/provisioning/template/' |
  'lottie/smartfolders/' |
  'video/' |
  'video/changelog/';

/**
 * Represents the relative paths of files located *directly* within a specific directory.
 * Use '.' for the root directory.
 * @template Dir - A directory path string literal type from StaticAssetDirectory (e.g., 'icons/', 'icons/sun/', '.').
 */
export type FilesInFolder<Dir extends '.' | StaticAssetDirectory> = 
  Dir extends '.'
    ? Exclude<StaticAssetPath, `${string}/${string}`>
    : Extract<StaticAssetPath, `${Dir}${string}`> extends infer Match
      ? Match extends `${Dir}${infer FileName}`
        ? FileName extends `${string}/${string}`
          ? never
          : Match
        : never
      : never;



const assets = new Set<string>([
  'images/arduino-logo-full.svg',
  'images/arduino-logo-round.svg',
  'images/arduino-logo-squared.png',
  'images/branding/cloudfavicon.dark.svg',
  'images/branding/cloudfavicon.svg',
  'images/branding/cloudhome.svg',
  'images/branding/cloudsidebar.svg',
  'images/classroom-logo.svg',
  'images/cloud-logo.svg',
  'images/covers/celebration.dark.svg',
  'images/covers/celebration.svg',
  'images/covers/connect-device.dark.svg',
  'images/covers/connect-device.svg',
  'images/covers/device-alert.dark.svg',
  'images/covers/device-alert.svg',
  'images/covers/device-confirm.dark.svg',
  'images/covers/device-confirm.svg',
  'images/covers/device-warning.dark.svg',
  'images/covers/device-warning.svg',
  'images/covers/documentation.dark.svg',
  'images/covers/documentation.svg',
  'images/covers/get-started.dark.svg',
  'images/covers/get-started.svg',
  'images/covers/no-device-found.dark.svg',
  'images/covers/no-device-found.svg',
  'images/dashboards/empty/1.dark.svg',
  'images/dashboards/empty/1.svg',
  'images/dashboards/empty/2.dark.svg',
  'images/dashboards/empty/2.svg',
  'images/dashboards/empty/3.dark.svg',
  'images/dashboards/empty/3.svg',
  'images/devices/boards/device-generic.svg',
  'images/devices/boards/device-mega.svg',
  'images/devices/boards/device-mkr.svg',
  'images/devices/boards/device-nano.svg',
  'images/devices/boards/device-opta.svg',
  'images/devices/boards/device-phone.svg',
  'images/devices/boards/device-portenta.svg',
  'images/devices/boards/device-uno.svg',
  'images/devices/boards/device-unoq.svg',
  'images/devices/boards/device-ventunoq.svg',
  'images/devices/chromeos_uploader/chromebook-reset-warning.png',
  'images/devices/chromeos_uploader/flash.png',
  'images/devices/device-alert.dark.svg',
  'images/devices/device-alert.svg',
  'images/devices/device-not-found.dark.svg',
  'images/devices/device-not-found.svg',
  'images/devices/empty-ota-list.dark.svg',
  'images/devices/empty-ota-list.svg',
  'images/devices/empty/1.dark.svg',
  'images/devices/empty/1.svg',
  'images/devices/empty/2.dark.svg',
  'images/devices/empty/2.svg',
  'images/devices/empty/3.dark.svg',
  'images/devices/empty/3.svg',
  'images/devices/qr-dev.jpeg',
  'images/devices/qr-prod.jpeg',
  'images/getting-started/1.dark.svg',
  'images/getting-started/1.svg',
  'images/getting-started/2.dark.svg',
  'images/getting-started/2.svg',
  'images/getting-started/3.dark.svg',
  'images/getting-started/3.svg',
  'images/getting-started/4.dark.svg',
  'images/getting-started/4.svg',
  'images/illustrations/auth-error.dark.svg',
  'images/illustrations/auth-error.svg',
  'images/illustrations/celebration.dark.svg',
  'images/illustrations/celebration.svg',
  'images/illustrations/createspace-edu.dark.svg',
  'images/illustrations/createspace-edu.svg',
  'images/illustrations/generic-error.dark.svg',
  'images/illustrations/generic-error.svg',
  'images/illustrations/generic-warning.dark.svg',
  'images/illustrations/generic-warning.svg',
  'images/illustrations/no-results.dark.svg',
  'images/illustrations/no-results.svg',
  'images/illustrations/sharing.svg',
  'images/integration/aws.dark.png',
  'images/integration/aws.png',
  'images/integration/blues.dark.png',
  'images/integration/blues.png',
  'images/integration/edge_impulse.png',
  'images/integration/foundries.dark.png',
  'images/integration/foundries.png',
  'images/integration/google_apps_script.png',
  'images/integration/google_classroom.png',
  'images/integration/grafana_labs.dark.png',
  'images/integration/grafana_labs.png',
  'images/integration/ifttt.png',
  'images/integration/node_red.dark.png',
  'images/integration/node_red.png',
  'images/integration/the_things_stack.png',
  'images/integration/zapier.png',
  'images/kits/AEKR2.png',
  'images/kits/AESK.png',
  'images/kits/BLOCK_BASED.png',
  'images/kits/BRACCIO.png',
  'images/kits/CTC101.png',
  'images/kits/CTCGO.png',
  'images/kits/ENGINEERING.png',
  'images/kits/EXPLORE_PHYSICS.png',
  'images/kits/EXPLORE_PLC.png',
  'images/kits/EXPLORE_ROBOTICS.png',
  'images/kits/GREENHOUSE.png',
  'images/kits/IOTSK.png',
  'images/kits/IOTSK2.png',
  'images/kits/MATTER_DISCOVERY.svg',
  'images/kits/OPLA.png',
  'images/kits/PHYSICSLAB.png',
  'images/kits/PlUG_AND_MAKE.png',
  'images/kits/SJ.png',
  'images/kits/STARTERKIT_R4.png',
  'images/kits/STUDENTKIT.png',
  'images/minorscontent/apple.svg',
  'images/minorscontent/arduinoIDEIcon.png',
  'images/minorscontent/arduinoIDEImg.png',
  'images/minorscontent/google.svg',
  'images/minorscontent/info2.png',
  'images/provisioning/any-device.dark.svg',
  'images/provisioning/any-device.svg',
  'images/provisioning/arduino-board.dark.svg',
  'images/provisioning/arduino-board.svg',
  'images/provisioning/bluetooth-connection.dark.svg',
  'images/provisioning/bluetooth-connection.svg',
  'images/provisioning/board-short-ble.svg',
  'images/provisioning/compatible-device.dark.svg',
  'images/provisioning/compatible-device.svg',
  'images/provisioning/configuration-modal-abort.dark.svg',
  'images/provisioning/configuration-modal-abort.svg',
  'images/provisioning/device-list.dark.svg',
  'images/provisioning/device-list.svg',
  'images/provisioning/new-device.dark.svg',
  'images/provisioning/new-device.svg',
  'images/provisioning/unoq.dark.svg',
  'images/provisioning/unoq.svg',
  'images/provisioning/usb-connection.dark.svg',
  'images/provisioning/usb-connection.svg',
  'images/resources/circuit.svg',
  'images/resources/discord.svg',
  'images/resources/help.svg',
  'images/resources/micropython.png',
  'images/resources/user.svg',
  'images/resources/youtube.svg',
  'images/setup/educators.png',
  'images/setup/intro.png',
  'images/setup/share-course.png',
  'images/sidebar-joinbanner.jpg',
  'images/sketches/empty/1.dark.svg',
  'images/sketches/empty/1.svg',
  'images/sketches/empty/2.dark.svg',
  'images/sketches/empty/2.svg',
  'images/sketches/empty/3.dark.svg',
  'images/sketches/empty/3.svg',
  'images/space-nologo.png',
  'images/templates/empty/1.dark.svg',
  'images/templates/empty/1.svg',
  'images/templates/empty/2.dark.svg',
  'images/templates/empty/2.svg',
  'images/templates/empty/3.dark.svg',
  'images/templates/empty/3.svg',
  'images/templates/empty/builder.dark.svg',
  'images/templates/empty/builder.svg',
  'images/templates/template-not-found.dark.svg',
  'images/templates/template-not-found.svg',
  'images/things/delete-smart-home.dark.svg',
  'images/things/delete-smart-home.svg',
  'images/things/empty/1.dark.svg',
  'images/things/empty/1.svg',
  'images/things/empty/2.dark.svg',
  'images/things/empty/2.svg',
  'images/things/empty/3.dark.svg',
  'images/things/empty/3.svg',
  'images/things/smart-home-integration.dark.svg',
  'images/things/smart-home-integration.svg',
  'images/things/thing-not-found.dark.svg',
  'images/things/thing-not-found.svg',
  'images/things/variables/empty.dark.svg',
  'images/things/variables/empty.svg',
  'images/things/variables/sync.dark.svg',
  'images/things/variables/sync.svg',
  'images/things/webhooks.dark.svg',
  'images/things/webhooks.svg',
  'images/triggers/empty/1.dark.svg',
  'images/triggers/empty/1.svg',
  'images/triggers/empty/2.dark.svg',
  'images/triggers/empty/2.svg',
  'images/triggers/empty/3.dark.svg',
  'images/triggers/empty/3.svg',
  'images/triggers/empty/thing-triggers-empty.dark.svg',
  'images/triggers/empty/thing-triggers-empty.svg',
  'images/triggers/trigger-not-found.dark.svg',
  'images/triggers/trigger-not-found.svg',
  'lottie/dashboards/dashboard-pages.lottie',
  'lottie/provisioning/connected/BLE_connecting_MEGA.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_MEGA.lottie',
  'lottie/provisioning/connected/BLE_connecting_MKR.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_MKR.lottie',
  'lottie/provisioning/connected/BLE_connecting_NANO.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_NANO.lottie',
  'lottie/provisioning/connected/BLE_connecting_OPTA.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_OPTA.lottie',
  'lottie/provisioning/connected/BLE_connecting_PORTENTA.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_PORTENTA.lottie',
  'lottie/provisioning/connected/BLE_connecting_UNOR4.dark.lottie',
  'lottie/provisioning/connected/BLE_connecting_UNOR4.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_MEGA.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_MEGA.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_MKR.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_MKR.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_NANO.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_NANO.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_OPTA.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_OPTA.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_PORTENTA.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_PORTENTA.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_UNOR4.dark.lottie',
  'lottie/provisioning/connected/SERIAL_connecting_UNOR4.lottie',
  'lottie/provisioning/connectivity_type/connectivity_type_OPTA.dark.lottie',
  'lottie/provisioning/connectivity_type/connectivity_type_OPTA.lottie',
  'lottie/provisioning/connectivity_type/connectivity_type_PORTENTA.dark.lottie',
  'lottie/provisioning/connectivity_type/connectivity_type_PORTENTA.lottie',
  'lottie/provisioning/error/Error_Generic.dark.lottie',
  'lottie/provisioning/error/Error_Generic.lottie',
  'lottie/provisioning/scanning/BLE_scanning_GENERIC.dark.lottie',
  'lottie/provisioning/scanning/BLE_scanning_GENERIC.lottie',
  'lottie/provisioning/scanning/SERIAL_scanning_GENERIC.dark.lottie',
  'lottie/provisioning/scanning/SERIAL_scanning_GENERIC.lottie',
  'lottie/provisioning/template/template_apply.dark.lottie',
  'lottie/provisioning/template/template_apply.lottie',
  'lottie/smartfolders/new-feature_smart-folder.lottie',
  'video/changelog/darktheme.dark.mp4',
  'video/changelog/darktheme.mp4',
  'video/changelog/sidebar.dark.mp4',
  'video/changelog/sidebar.mp4',
  'video/changelog/thing.dark.mp4',
  'video/changelog/thing.mp4',
  'video/walkthrough.mp4'
]);

// Store basePath resolved from Vite config
const BASE_PATH = "/";


/**
 * Gets the URL for a specific static asset
 * @param path Path to the asset
 * @returns The URL for the asset
 */
export function staticAssets(path: StaticAssetPath): string {
  if (!assets.has(path)) {
    throw new Error(
      "Static asset does not exist in static assets directory"
    );
  }
  return `${BASE_PATH}${path}`;
}

